import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [currency, setCurrency] = useState(localStorage.getItem("ep_currency") || "GBP");

  useEffect(() => {
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser(false));
  }, []);

  const login = useCallback(async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("ep_token", data.token);
    setUser(data.user);
    const def = { admin: "GBP", regional_manager: "EUR", store_user: "USD", warehouse: "GBP" }[data.user.role];
    if (def) changeCurrency(def);
    return data.user;
  }, []);

  const logout = useCallback(async () => {
    await api.post("/auth/logout").catch(() => {});
    localStorage.removeItem("ep_token");
    setUser(false);
  }, []);

  const changeCurrency = (c) => {
    localStorage.setItem("ep_currency", c);
    setCurrency(c);
  };

  return <AuthCtx.Provider value={{ user, login, logout, currency, setCurrency: changeCurrency }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
